// extracted by mini-css-extract-plugin
export default {"bar":"FootBar_bar__kSxAT","poweredby":"FootBar_poweredby__MvxN7","logos":"FootBar_logos__x9Y5G","logo":"FootBar_logo__t1Pu9"};